import GuiContext from "config/context/guiContext";
import { useContext, useEffect, useState } from "react";

/**
 * Katalog migriranih import plugin-ova sa servera.
 *
 * `GET /api/imports/` vraća, za svaki plugin, `slug`, `name`, `source` i
 * `configSchema` — spisak polja koja mu trebaju, sa tipom, oznakom obaveznosti
 * i natpisom. Forma se odatle GRADI, umesto da se piše po jedna po izvoru.
 *
 * Zbog toga dodavanje plugin-a u `manifest.js` na backendu odmah daje i formu
 * u GUI-ju, bez ijedne izmene ovde. Zatečeno stanje je bilo suprotno: pet
 * ručno pisanih dijaloga, a lista podržanih formata ukucana na tri mesta koja
 * se nisu poklapala.
 *
 * @returns {{catalog: Array, byFile: Array, byConnection: Array, loading: boolean, error: string|null}}
 */
export const useImportCatalog = () => {
    const [catalog, setCatalog] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { URL } = useContext(GuiContext);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${URL}/api/imports/`, { credentials: "include" });
                const data = await res.json();
                if (cancelled) return;

                if (data?.status) {
                    setCatalog(data.imports || []);
                } else {
                    setError(data?.message || "Could not read the import catalog");
                }
            } catch (err) {
                if (!cancelled) setError(err.message || "Could not reach the server");
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();
        return () => { cancelled = true; };
    }, [URL]);

    return {
        catalog,
        // Fajl se otprema, konekcija se popunjava — dva različita prva koraka.
        byFile: catalog.filter((p) => p.source === "file"),
        byConnection: catalog.filter((p) => p.source === "connection"),
        loading,
        error,
    };
};
